// meshCulling.js
var MeshCulling = pc.createScript('meshCulling');

// initialize code called once per entity
MeshCulling.prototype.initialize = function() {
  
    
    // occluder
    var meshInstances = this.entity.model.meshInstances;
    var mat;
    for(var i=0; i<meshInstances.length; i++) {
        mat = meshInstances[i].material;
        mat.redWrite = mat.greenWrite = mat.blueWrite = false; // don't render occluder to color
        mat.blendType = pc.CLEARFLAG_STENCIL; // render occluder after all opaque objects (skybox)
    }
    
    var sph = this.app.root.findByName("basePlanet").model.meshInstances[0];
    mat = sph.material;
    mat.blendType = pc.BLEND_NORMAL; // render sphere also after all opaque objects
    
};

